<ng-container>
  <div>
    <mat-checkbox [disabled]="disableToggle" [checked]="value === true" (change)="onCheckboxChange($event.checked)">
    </mat-checkbox>
  </div>
</ng-container>